<template>
  <path
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1"
    d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
  />
</template>
